import React, {useEffect} from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'
import { Button } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import CustomToolbar from './CustomToolbarPrint';


import { collection, query, getDocs } from "firebase/firestore"; 
import {db} from "../firebase.js";


export default function Archived() {
    const [rows, setRows] = React.useState([])

    let arr = [];
  
    useEffect( () => {
      test()
  
      async function test(){
        arr=[]
        getData()
      }
  
      setRows(arr)
      console.log(arr)
  
  }, []);
  
  async function getData (){
    console.log("me chala")
    let arr = []
    const q = query(collection(db, "archivedStaff"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      arr.push(obj)
     });  
  
     setRows(arr)
  
  }
  
  
  
    const navigate = useNavigate();
    const columns = [
      { field: 'firstName', headerName: 'Name', width: 150 },
      { field: 'surName', headerName: 'Surname', width: 150 },
      {
          field: 'startDate',
          headerName: 'Start Date',
          width: 170 
        },
        { field: 'jobTitle', headerName: 'Job Title' , width: 150 },
        { field: 'contact', headerName: 'Contact Number' , width: 150 },
        { field: 'email', headerName: 'Email Address' , width: 150 },
        { field: 'volunteer', headerName: 'Volunteer' , width: 150 },
      
    ];
  
    const handleRowClick = (params) => {
      //console.log(params.row);
      navigate("/profileArchivedStaff",{
        state: {
          employee: params.row,
        }
      });
    };
    
    return (
  
        
  
        <Box sx={{ display: 'flex' }}>
          <Sidebar />
       
         
          <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{marginTop: "50px", justifyContent: "center", alignItems: "center"}}>
         
          <div style={{ height: 640, width: '100%'}}>
              <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  //checkboxSelection
                  onRowDoubleClick={handleRowClick}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />
          </div>
          
        </Box>
       
          
      </Box>
  
      
    )
}
